import Backbone from '@polleverywhere/backbone'
import Visualization from '@polleverywhere/toolkit/components/visualization'
import './style.scss'

export default class AgavePresenter extends Backbone.View {
  initialize (options = {}) {
    this.options = options
  }

  get className () { return 'ms-agave__presenter' }

  render () {
    const viz = new Visualization({
      model: this.options.model,
      iframeMode: true,
      aspectRatio: false
    })
    this.$el.append(viz.render().$el)
    return this
  }
}
